module.exports = __webpack_public_path__ + "static/media/Electrical.0f18a610.jpg";